<template>
  <v-dialog v-model="visible" persistent max-width="320">
    <v-card>
      <v-card-title class="headline">You've been signed out</v-card-title>
      <v-card-text>
        For your security, we've signed you out because your password was
        changed in another session. Please log in again to continue.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="logout">Log in again</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { authServiceInstance } from "@auth";

export default {
  name: "ForceLogoutModal",
  computed: {
    ...mapState(["forceLogoutRequired"]),
    visible: {
      get() {
        return this.forceLogoutRequired;
      },
      // keep dialog persistent; ignore manual close attempts
      set() {},
    },
  },
  methods: {
    async logout() {
      await authServiceInstance.logout();
      this.$store.commit("setForceLogoutRequired", false);
      this.$router.push("/auth/login");
    },
  },
};
</script>
